module.exports = __webpack_public_path__ + "static/media/arrow_small_blue.246ad409.svg";